import Image from "next/image";
import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import BeniftContent from "./BeniftContent";
import { useWindowSize } from "../../hooks/useWindowSize";

const Benifits = () => {
  const [videoModalBrand, setvideoModalBrand] = useState(false);
  const [videoModalCreator, setvideoModalCreator] = useState(false);
  const windowSize = useWindowSize();
  const [videoModalImpactIntiative, setvideoModalImpactIntiative] =
    useState(false);

  const [videoModalSupporters, setvideoModalSupporters] = useState(false);

  const handleVideo = () => {
    var iframes = document.querySelectorAll("iframe");
    const elementsArray = Array.from(iframes);
    for (var i = 0; i < elementsArray.length; i++) {
      const src = elementsArray[i].src;
      if (src && src.includes("youtube.com")) {
        // Replace "autoplay=1" with "autoplay=0" to stop the video
        elementsArray[i].src = src.replace("autoplay=1", "autoplay=0");
      }
    }
  };
  return (
    <>
      {/* <!-- Benefits --> */}
      <section className="py-24 dark:bg-jacarta-900">
        <div className="container">
          <div className="mx-auto mb-16 text-center">
            <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-5xl text-center uppercase">
              THE ECOSYSTEM
            </h2>

            <p className="text-lg dark:text-jacarta-300">
              Our Impact Art campaigns are a great way to collaborate to raise
              funds with mutual benefits. Here&apos;s an overview of how it
              works.
            </p>
            {/* <p className="text-lg dark:text-jacarta-300">
              We empower artists, creators, and players to build the platform
              they always envisioned, providing the means to unleash your
              creativity and earn income.
            </p> */}
          </div>
          <Tabs>
            <div className="lg:flex lg:flex-nowrap lg:space-x-10 benifit">
              <div className="lg:w-[43%]">
                {/* <!-- tabs --> */}

                <TabList className="nav nav-tabs mb-12 space-y-2">
                  {/* Impact Intiatives */}
                  <Tab className="nav-item">
                    <button
                      className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                      type="button"
                      onClick={() => {
                        if (windowSize?.width <= 1024) {
                          setvideoModalImpactIntiative(true);
                        }
                      }}
                    >
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        zoomAndPan="magnify"
                        viewBox="0 0 45 44.999999"
                        height="60"
                        preserveAspectRatio="xMidYMid meet"
                        version="1.0"
                        className="mr-2 h-8 w-8 flex-shrink-0 fill-accent"
                      >
                        <defs>
                          <clipPath id="50d73e4c8b">
                            <path
                              d="M 8.691406 30 L 36.421875 30 L 36.421875 44.75 L 8.691406 44.75 Z M 8.691406 30 "
                              clipRule="nonzero"
                            />
                          </clipPath>
                          <clipPath id="130874342a">
                            <path
                              d="M 8.691406 0.25 L 36.421875 0.25 L 36.421875 15 L 8.691406 15 Z M 8.691406 0.25 "
                              clipRule="nonzero"
                            />
                          </clipPath>
                        </defs>

                        <g clipPath="url(#50d73e4c8b)">
                          <path
                            d="M 24.574219 37.523438 L 26.1875 37.523438 C 26.589844 37.515625 26.957031 37.355469 27.222656 37.09375 L 33.867188 30.480469 C 34.457031 29.902344 35.402344 29.902344 35.984375 30.484375 C 36.570312 31.066406 36.570312 32.007812 35.984375 32.589844 L 35.988281 32.589844 L 27.335938 41.199219 C 27.066406 41.460938 26.695312 41.632812 26.285156 41.632812 C 26.21875 41.632812 26.15625 41.632812 26.09375 41.636719 L 18.171875 41.636719 C 18.144531 41.636719 18.117188 41.632812 18.089844 41.632812 L 18.089844 41.636719 C 17.859375 41.636719 16.511719 41.640625 16.316406 41.636719 C 16.117188 41.628906 15.914062 41.703125 15.753906 41.855469 L 12.84375 44.75 L 8.753906 44.75 C 8.742188 44.679688 8.753906 39.894531 8.753906 39.894531 C 8.746094 39.515625 8.890625 39.132812 9.179688 38.832031 L 13.886719 34.183594 C 13.894531 34.171875 13.898438 34.167969 13.90625 34.160156 L 14.003906 34.070312 L 14.011719 34.070312 C 14.90625 33.242188 16.175781 32.980469 17.480469 32.980469 L 24.496094 32.980469 C 25.324219 32.980469 25.996094 33.648438 25.996094 34.46875 C 25.996094 35.292969 25.324219 35.960938 24.496094 35.960938 L 24.496094 35.964844 L 19.011719 35.964844 C 18.578125 35.964844 18.226562 36.3125 18.226562 36.742188 C 18.222656 37.171875 18.578125 37.523438 19.007812 37.523438 L 24.574219 37.523438 "
                            fillOpacity="1"
                            fillRule="nonzero"
                          >
                            <animate
                              attributeName="opacity"
                              values="1;0.5;1"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </g>
                        <g clipPath="url(#130874342a)">
                          <path
                            d="M 20.539062 7.480469 L 18.925781 7.476562 C 18.523438 7.484375 18.160156 7.644531 17.894531 7.90625 L 11.242188 14.519531 C 10.660156 15.097656 9.714844 15.097656 9.128906 14.515625 C 8.542969 13.933594 8.542969 12.996094 9.128906 12.410156 L 9.125 12.410156 L 17.777344 3.800781 C 18.050781 3.535156 18.417969 3.371094 18.832031 3.371094 C 18.898438 3.371094 18.957031 3.367188 19.019531 3.363281 L 26.945312 3.363281 C 26.972656 3.363281 27 3.367188 27.023438 3.367188 L 27.023438 3.363281 C 27.257812 3.363281 28.601562 3.359375 28.792969 3.363281 C 28.996094 3.371094 29.203125 3.296875 29.359375 3.144531 L 32.269531 0.25 L 36.363281 0.25 C 36.375 0.324219 36.359375 5.105469 36.359375 5.105469 C 36.367188 5.484375 36.222656 5.871094 35.9375 6.164062 L 31.222656 10.816406 C 31.21875 10.824219 31.210938 10.832031 31.207031 10.839844 L 31.113281 10.929688 L 31.105469 10.929688 C 30.207031 11.757812 28.941406 12.019531 27.632812 12.019531 L 20.613281 12.019531 C 19.789062 12.019531 19.121094 11.351562 19.121094 10.53125 C 19.121094 9.707031 19.789062 9.039062 20.613281 9.039062 L 20.613281 9.035156 L 26.105469 9.035156 C 26.539062 9.035156 26.886719 8.6875 26.886719 8.257812 C 26.886719 7.828125 26.539062 7.476562 26.105469 7.476562 L 21.464844 7.480469 L 20.539062 7.480469 "
                            fillOpacity="1"
                            fillRule="nonzero"
                          >
                            <animate
                              attributeName="opacity"
                              values="1;0.5;1"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </g>
                        <path
                          d="M 25.441406 23.910156 C 25.441406 25.199219 24.59375 26 23.320312 26.203125 L 23.320312 27.210938 L 21.621094 27.210938 L 21.621094 26.144531 C 20.609375 25.980469 19.796875 25.347656 19.796875 25.347656 L 20.742188 24.105469 C 20.742188 24.105469 21.609375 24.789062 22.6875 24.789062 C 23.371094 24.789062 23.78125 24.515625 23.78125 24.074219 L 23.78125 24.046875 C 23.78125 23.628906 23.519531 23.414062 22.25 23.089844 C 20.722656 22.703125 19.730469 22.277344 19.730469 20.777344 L 19.730469 20.757812 C 19.730469 19.625 20.488281 18.804688 21.621094 18.558594 L 21.621094 17.667969 L 23.320312 17.667969 L 23.320312 18.570312 C 24.210938 18.660156 24.804688 19.140625 24.804688 19.140625 L 23.964844 20.453125 C 23.964844 20.453125 23.300781 19.945312 22.371094 19.945312 C 21.730469 19.945312 21.394531 20.238281 21.394531 20.605469 L 21.394531 20.625 C 21.394531 21.121094 21.71875 21.285156 23.03125 21.617188 C 24.574219 22.019531 25.441406 22.566406 25.441406 23.886719 Z M 22.585938 14.082031 C 17.945312 14.082031 14.1875 17.824219 14.1875 22.441406 C 14.1875 27.054688 17.945312 30.800781 22.585938 30.800781 C 27.226562 30.800781 30.988281 27.054688 30.988281 22.441406 C 30.988281 17.824219 27.226562 14.082031 22.585938 14.082031 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        zoomAndPan="magnify"
                        viewBox="0 0 45 44.999999"
                        height="60"
                        preserveAspectRatio="xMidYMid meet"
                        version="1.0"
                        className="mr-2 h-8 w-8 flex-shrink-0 fill-accent"
                      >
                        <defs>
                          <clipPath id="2b124ae43c">
                            <path
                              d="M 3.066406 0 L 42 0 L 42 45 L 3.066406 45 Z M 3.066406 0 "
                              clipRule="nonzero"
                            >
                              <animate
                                attributeName="opacity"
                                values="1;0.5;1"
                                dur="2s"
                                repeatCount="indefinite"
                              />
                            </path>
                          </clipPath>
                        </defs>

                        <g clipPath="url(#2b124ae43c)">
                          <path
                            d="M 40.128906 31.851562 C 39.996094 32.375 39.660156 32.816406 39.183594 33.09375 C 38.691406 33.375 37.980469 33.804688 37.152344 34.300781 C 35.015625 35.585938 31.789062 37.527344 28.875 39.082031 C 24.453125 41.441406 22.933594 41.742188 22.417969 41.714844 C 17.996094 41.46875 13.472656 40.628906 9.035156 41.328125 L 9.035156 32.949219 C 10.082031 32.894531 11.328125 32.785156 12.582031 32.511719 C 13.367188 32.339844 14.777344 31.65625 16.253906 30.949219 C 19.160156 29.558594 19.382812 29.605469 22.082031 30.191406 C 23.410156 30.480469 27.589844 31.238281 27.605469 32.707031 C 27.609375 33.03125 27.527344 33.347656 27.367188 33.632812 C 27.316406 33.664062 27.269531 33.703125 27.226562 33.746094 C 26.820312 34.203125 26.207031 34.445312 25.59375 34.394531 L 18.46875 33.824219 C 18.089844 33.792969 17.761719 34.074219 17.730469 34.449219 C 17.699219 34.824219 17.980469 35.152344 18.359375 35.183594 L 25.484375 35.753906 C 25.570312 35.761719 25.660156 35.765625 25.75 35.765625 C 26.605469 35.765625 27.441406 35.433594 28.0625 34.847656 C 28.085938 34.835938 28.113281 34.824219 28.140625 34.808594 L 37.039062 29.660156 C 38.613281 28.75 40.566406 30.117188 40.128906 31.851562 Z M 7.667969 43.414062 C 7.667969 43.53125 7.566406 43.628906 7.449219 43.628906 L 4.671875 43.628906 C 4.554688 43.628906 4.457031 43.53125 4.457031 43.414062 L 4.457031 31.636719 C 4.457031 31.519531 4.554688 31.421875 4.671875 31.421875 L 7.449219 31.421875 C 7.566406 31.421875 7.667969 31.519531 7.667969 31.636719 Z M 14.050781 17.300781 C 10.941406 21.15625 10.558594 26.589844 13.214844 30.851562 C 13.597656 30.691406 14.042969 30.488281 14.507812 30.269531 C 14.609375 30.046875 14.71875 29.832031 14.832031 29.628906 C 15.628906 28.15625 17.40625 26.734375 17.542969 26.46875 C 17.675781 26.214844 17.070312 25.367188 17.46875 24.332031 C 17.890625 23.25 19.136719 22.867188 18.507812 21.496094 C 17.78125 19.921875 14.808594 20.714844 14.050781 17.300781 Z M 21.308594 3.300781 C 21.308594 2.230469 22.183594 1.359375 23.257812 1.359375 C 24.332031 1.359375 25.207031 2.230469 25.207031 3.300781 C 25.207031 4.371094 24.332031 5.242188 23.257812 5.242188 C 22.183594 5.242188 21.308594 4.371094 21.308594 3.300781 Z M 35.066406 24.660156 C 35.066406 16.972656 27.769531 11.375 20.34375 13.257812 C 21.132812 13.625 21.808594 14.042969 22.363281 14.515625 C 25.472656 17.171875 23.652344 19.921875 24.785156 20.988281 C 26.011719 22.152344 28.960938 20.429688 30.246094 22.355469 C 30.808594 23.199219 30.617188 24.296875 30.476562 25.101562 C 30.324219 25.984375 30.433594 26.160156 30.441406 26.164062 C 30.582031 26.320312 31.796875 26.320312 32.742188 27.53125 C 33.1875 28.101562 33.457031 28.890625 33.597656 30.074219 L 33.804688 29.957031 C 34.628906 28.324219 35.066406 26.5 35.066406 24.660156 Z M 25.324219 29.574219 C 26.890625 30.042969 28.96875 30.878906 28.972656 32.6875 C 28.972656 32.707031 28.972656 32.730469 28.972656 32.75 L 32.308594 30.820312 C 32.289062 30.671875 32.273438 30.535156 32.257812 30.402344 C 32.152344 29.414062 31.957031 28.746094 31.664062 28.367188 C 30.855469 27.335938 29.84375 27.824219 29.265625 26.863281 C 28.601562 25.757812 29.621094 23.882812 29.105469 23.113281 C 28.445312 22.121094 25.5625 23.609375 23.839844 21.976562 C 22.996094 21.175781 22.984375 20.175781 22.976562 19.207031 C 22.964844 18.03125 22.949219 16.816406 21.46875 15.550781 C 20.722656 14.910156 19.679688 14.375 18.371094 13.949219 C 17.226562 14.472656 16.179688 15.167969 15.265625 16.007812 C 15.304688 16.832031 15.453125 17.441406 15.726562 17.910156 C 16.589844 19.382812 18.8125 18.890625 19.75 20.929688 C 20.511719 22.585938 19.683594 23.597656 19.136719 24.269531 C 18.679688 24.828125 18.609375 24.917969 18.796875 25.597656 C 18.898438 25.976562 19.039062 26.492188 18.777344 27.054688 C 18.652344 27.324219 18.402344 27.578125 17.890625 28.078125 C 17.566406 28.394531 17.179688 28.773438 16.820312 29.183594 C 19.050781 28.203125 19.777344 28.296875 22.371094 28.859375 C 23.324219 29.066406 24.265625 29.253906 25.324219 29.574219 Z M 5.921875 8.230469 C 5.921875 7.160156 6.796875 6.289062 7.871094 6.289062 C 8.945312 6.289062 9.816406 7.160156 9.816406 8.230469 C 9.816406 9.300781 8.945312 10.171875 7.871094 10.171875 C 6.796875 10.171875 5.921875 9.300781 5.921875 8.230469 Z M 36.699219 8.230469 C 36.699219 7.160156 37.570312 6.289062 38.644531 6.289062 C 39.71875 6.289062 40.59375 7.160156 40.59375 8.230469 C 40.59375 9.300781 39.71875 10.171875 38.644531 10.171875 C 37.570312 10.171875 36.699219 9.300781 36.699219 8.230469 Z M 36.351562 28.480469 L 35.753906 28.828125 C 36.773438 25.785156 36.640625 22.5 35.410156 19.582031 L 38.070312 18.050781 C 38.871094 17.589844 39.328125 16.796875 39.328125 15.875 L 39.328125 11.464844 C 40.832031 11.148438 41.960938 9.820312 41.960938 8.230469 C 41.960938 6.410156 40.476562 4.925781 38.644531 4.925781 C 36.816406 4.925781 35.332031 6.410156 35.332031 8.230469 C 35.332031 9.820312 36.460938 11.148438 37.960938 11.464844 L 37.960938 15.875 C 37.960938 16.304688 37.757812 16.65625 37.386719 16.871094 L 34.8125 18.351562 C 32.671875 14.476562 28.625 11.789062 23.941406 11.546875 L 23.941406 6.535156 C 25.445312 6.21875 26.574219 4.886719 26.574219 3.300781 C 26.574219 1.476562 25.085938 -0.00390625 23.257812 -0.00390625 C 21.429688 -0.00390625 19.941406 1.476562 19.941406 3.300781 C 19.941406 4.886719 21.070312 6.21875 22.574219 6.535156 L 22.574219 11.546875 C 17.890625 11.789062 13.84375 14.476562 11.703125 18.351562 L 9.128906 16.871094 C 8.757812 16.65625 8.554688 16.304688 8.554688 15.875 L 8.554688 11.464844 C 10.054688 11.148438 11.183594 9.820312 11.183594 8.230469 C 11.183594 6.410156 9.699219 4.925781 7.871094 4.925781 C 6.042969 4.925781 4.554688 6.410156 4.554688 8.230469 C 4.554688 9.820312 5.683594 11.148438 7.1875 11.464844 L 7.1875 15.875 C 7.1875 16.796875 7.644531 17.589844 8.445312 18.050781 L 11.105469 19.582031 C 9.511719 23.347656 9.78125 27.703125 11.867188 31.265625 C 10.871094 31.453125 9.886719 31.539062 9.03125 31.585938 C 9.003906 30.738281 8.308594 30.058594 7.449219 30.058594 L 4.671875 30.058594 C 3.796875 30.058594 3.085938 30.765625 3.085938 31.636719 L 3.085938 43.414062 C 3.085938 44.285156 3.796875 44.992188 4.671875 44.992188 L 7.449219 44.992188 C 8.324219 44.992188 9.035156 44.285156 9.035156 43.414062 L 9.035156 42.710938 C 12.058594 42.191406 15.070312 42.457031 18.445312 42.765625 C 19.703125 42.882812 21.003906 43 22.339844 43.078125 C 24.757812 43.230469 31.808594 39.105469 37.859375 35.46875 C 38.679688 34.976562 39.390625 34.550781 39.871094 34.273438 C 41.503906 33.324219 42.050781 31.246094 41.070312 29.648438 C 40.097656 28.0625 37.980469 27.539062 36.351562 28.480469 Z M 36.351562 28.480469 "
                            fillOpacity="1"
                            fillRule="evenodd"
                          >
                            <animate
                              attributeName="opacity"
                              values="1;0.5;1"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </g>
                      </svg>
                      <div>
                        <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white  transition-colors">
                          Virtual World of Impact
                        </span>
                        <div className="nav-link-content hidden">
                          <p className="text-jacarta-500 dark:text-jacarta-300">
                            Leveraging digital technologies, our virtual world
                            serves as a platform to showcase impact innovations,
                            causes and impact-aligned brands within a space
                            dedicated to engagement and collaboration that makes
                            a difference in the real world.
                          </p>
                        </div>
                      </div>
                    </button>
                  </Tab>
                  {/* Brands & Influencers */}
                  <Tab className="nav-item">
                    <button
                      className="nav-link nav-link--style-2  group relative flex w-full border-jacarta-100 p-6 text-left dark:border-jacarta-600 dark:bg-transpare"
                      type="button"
                      onClick={() => {
                        if (windowSize?.width <= 1024) {
                          setvideoModalBrand(true);
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        zoomAndPan="magnify"
                        viewBox="0 0 45 44.999999"
                        height="60"
                        preserveAspectRatio="xMidYMid meet"
                        version="1.0"
                        className="mr-2 h-8 w-8 flex-shrink-0 fill-accent"
                      >
                        <path
                          d="M 26.207031 42 L 18.75 42 C 18.75 43.65625 20.09375 45 21.75 45 L 23.207031 45 C 24.863281 45 26.207031 43.65625 26.207031 42 Z M 26.207031 42 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 12.015625 20.625 L 12.085938 21.429688 C 12.25 23.304688 13.878906 24.75 15.835938 24.75 L 16.269531 24.75 C 17.265625 24.75 18.222656 24.367188 18.929688 23.691406 L 19.839844 22.808594 C 20.546875 22.132812 21.503906 21.75 22.5 21.75 C 23.496094 21.75 24.453125 22.132812 25.160156 22.808594 L 26.070312 23.691406 C 26.777344 24.367188 27.734375 24.75 28.730469 24.75 L 29.164062 24.75 C 31.121094 24.75 32.75 23.304688 32.914062 21.429688 L 32.984375 20.625 C 33.210938 18 31.058594 15.75 28.324219 15.75 L 16.675781 15.75 C 13.941406 15.75 11.789062 18 12.015625 20.625 Z M 30 20.25 C 30.414062 20.25 30.75 20.585938 30.75 21 C 30.75 21.414062 30.414062 21.75 30 21.75 C 29.585938 21.75 29.25 21.414062 29.25 21 C 29.25 20.585938 29.585938 20.25 30 20.25 Z M 28.5 18 C 28.914062 18 29.25 18.335938 29.25 18.75 C 29.25 19.164062 28.914062 19.5 28.5 19.5 C 28.085938 19.5 27.75 19.164062 27.75 18.75 C 27.75 18.335938 28.085938 18 28.5 18 Z M 27 20.25 C 27.414062 20.25 27.75 20.585938 27.75 21 C 27.75 21.414062 27.414062 21.75 27 21.75 C 26.585938 21.75 26.25 21.414062 26.25 21 C 26.25 20.585938 26.585938 20.25 27 20.25 Z M 14.25 19.5 L 15.75 19.5 L 15.75 18 L 17.25 18 L 17.25 19.5 L 18.75 19.5 L 18.75 21 L 17.25 21 L 17.25 22.5 L 15.75 22.5 L 15.75 21 L 14.25 21 Z M 14.25 19.5 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 15.648438 36.324219 C 17.097656 37.285156 18 38.824219 18 40.5 L 27 40.5 C 27 38.824219 27.902344 37.285156 29.351562 36.324219 C 32.464844 34.273438 34.5 30.863281 34.5 27 L 10.5 27 C 10.5 30.863281 12.535156 34.273438 15.648438 36.324219 Z M 22.5 34.5 C 21.257812 34.5 20.25 33.492188 20.25 32.25 C 20.25 31.273438 20.878906 30.449219 21.75 30.136719 L 21.75 29.25 L 23.25 29.25 L 23.25 30.136719 C 24.121094 30.449219 24.75 31.273438 24.75 32.25 L 23.25 32.25 C 23.25 31.835938 22.914062 31.5 22.5 31.5 C 22.085938 31.5 21.75 31.835938 21.75 32.25 C 21.75 32.664062 22.085938 33 22.5 33 C 23.742188 33 24.75 34.007812 24.75 35.25 C 24.75 36.226562 24.121094 37.050781 23.25 37.363281 L 23.25 38.25 L 21.75 38.25 L 21.75 37.363281 C 20.878906 37.050781 20.25 36.226562 20.25 35.25 L 21.75 35.25 C 21.75 35.664062 22.085938 36 22.5 36 C 22.914062 36 23.25 35.664062 23.25 35.25 C 23.25 34.835938 22.914062 34.5 22.5 34.5 Z M 22.5 34.5 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 36.722656 23.152344 L 35.976562 23.070312 L 35.222656 23.070312 C 35.195312 23.546875 35.136719 24.023438 35.054688 24.492188 L 36.535156 24.75 C 36.625 24.226562 36.6875 23.695312 36.722656 23.152344 Z M 36.722656 23.152344 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 8.4375 24.589844 L 9.917969 24.347656 C 9.839844 23.878906 9.789062 23.402344 9.765625 22.925781 L 8.269531 23 C 8.292969 23.53125 8.351562 24.066406 8.4375 24.589844 Z M 8.4375 24.589844 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 35.078125 20.175781 C 35.15625 20.644531 35.207031 21.121094 35.234375 21.59375 L 36.730469 21.515625 C 36.703125 20.988281 36.644531 20.453125 36.558594 19.929688 Z M 35.078125 20.175781 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 8.28125 21.355469 L 8.277344 21.414062 L 9.777344 21.472656 C 9.804688 21.003906 9.859375 20.535156 9.941406 20.074219 L 8.460938 19.816406 C 8.371094 20.332031 8.3125 20.855469 8.28125 21.355469 Z M 8.28125 21.355469 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />{" "}
                        </path>
                        <path
                          d="M 34.300781 17.429688 C 34.480469 17.871094 34.636719 18.324219 34.765625 18.78125 L 36.210938 18.371094 C 36.066406 17.859375 35.890625 17.351562 35.6875 16.859375 Z M 34.300781 17.429688 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 8.824219 18.261719 L 10.261719 18.683594 C 10.398438 18.226562 10.558594 17.773438 10.742188 17.335938 L 9.359375 16.757812 C 9.152344 17.246094 8.972656 17.75 8.824219 18.261719 Z M 8.824219 18.261719 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 33.683594 16.140625 L 34.996094 15.421875 C 34.742188 14.957031 34.457031 14.5 34.152344 14.066406 L 32.925781 14.929688 C 33.199219 15.320312 33.453125 15.726562 33.683594 16.140625 Z M 33.683594 16.140625 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />{" "}
                        </path>
                        <path
                          d="M 11.367188 16.050781 C 11.597656 15.636719 11.859375 15.230469 12.132812 14.84375 L 10.917969 13.96875 C 10.605469 14.402344 10.320312 14.855469 10.058594 15.316406 Z M 11.367188 16.050781 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 33.160156 12.816406 C 32.808594 12.417969 32.429688 12.039062 32.035156 11.679688 L 31.03125 12.796875 C 31.382812 13.113281 31.722656 13.457031 32.039062 13.808594 Z M 33.160156 12.816406 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />{" "}
                        </path>
                        <path
                          d="M 14.046875 12.726562 L 13.054688 11.601562 C 12.65625 11.953125 12.273438 12.332031 11.917969 12.726562 L 13.03125 13.730469 C 13.351562 13.378906 13.691406 13.039062 14.046875 12.726562 Z M 14.046875 12.726562 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />{" "}
                        </path>
                        <path
                          d="M 30.792969 10.679688 C 30.363281 10.371094 29.90625 10.082031 29.441406 9.824219 L 28.710938 11.132812 C 29.125 11.363281 29.53125 11.621094 29.914062 11.898438 Z M 30.792969 10.679688 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 16.382812 11.082031 L 15.660156 9.769531 C 15.195312 10.023438 14.742188 10.304688 14.304688 10.613281 L 15.167969 11.839844 C 15.558594 11.566406 15.964844 11.3125 16.382812 11.082031 Z M 16.382812 11.082031 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 28.003906 9.125 C 27.515625 8.917969 27.007812 8.738281 26.496094 8.589844 L 26.078125 10.03125 C 26.535156 10.164062 26.988281 10.324219 27.425781 10.507812 Z M 28.003906 9.125 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 19.023438 10 L 18.609375 8.558594 C 18.097656 8.703125 17.589844 8.878906 17.101562 9.078125 L 17.671875 10.46875 C 18.109375 10.289062 18.5625 10.132812 19.023438 10 Z M 19.023438 10 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 23.355469 8.046875 L 23.300781 9.546875 C 23.765625 9.574219 24.230469 9.628906 24.683594 9.710938 L 24.941406 8.230469 C 24.433594 8.144531 23.910156 8.082031 23.390625 8.050781 Z M 23.355469 8.046875 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 21.835938 9.539062 L 21.757812 8.039062 C 21.226562 8.066406 20.691406 8.125 20.171875 8.210938 L 20.414062 9.691406 C 20.878906 9.613281 21.359375 9.5625 21.835938 9.539062 Z M 21.835938 9.539062 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 6 5.863281 L 6 6.75 C 6 7.035156 6.160156 7.292969 6.414062 7.421875 L 9 8.714844 L 9 12 L 10.5 12 L 10.5 8.25 C 10.5 7.964844 10.339844 7.707031 10.085938 7.578125 L 7.5 6.285156 L 7.5 5.863281 C 8.371094 5.550781 9 4.726562 9 3.75 C 9 2.507812 7.992188 1.5 6.75 1.5 C 5.507812 1.5 4.5 2.507812 4.5 3.75 C 4.5 4.726562 5.128906 5.550781 6 5.863281 Z M 6.75 3 C 7.164062 3 7.5 3.335938 7.5 3.75 C 7.5 4.164062 7.164062 4.5 6.75 4.5 C 6.335938 4.5 6 4.164062 6 3.75 C 6 3.335938 6.335938 3 6.75 3 Z M 6.75 3 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 21.75 4.363281 L 21.75 7.5 L 23.25 7.5 L 23.25 4.363281 C 24.121094 4.050781 24.75 3.226562 24.75 2.25 C 24.75 1.007812 23.742188 0 22.5 0 C 21.257812 0 20.25 1.007812 20.25 2.25 C 20.25 3.226562 20.878906 4.050781 21.75 4.363281 Z M 22.5 1.5 C 22.914062 1.5 23.25 1.835938 23.25 2.25 C 23.25 2.664062 22.914062 3 22.5 3 C 22.085938 3 21.75 2.664062 21.75 2.25 C 21.75 1.835938 22.085938 1.5 22.5 1.5 Z M 22.5 1.5 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 36.75 8.714844 L 39.335938 7.421875 C 39.589844 7.292969 39.75 7.035156 39.75 6.75 L 39.75 5.863281 C 40.621094 5.550781 41.25 4.726562 41.25 3.75 C 41.25 2.507812 40.242188 1.5 39 1.5 C 37.757812 1.5 36.75 2.507812 36.75 3.75 C 36.75 4.726562 37.378906 5.550781 38.25 5.863281 L 38.25 6.285156 L 35.664062 7.578125 C 35.410156 7.707031 35.25 7.964844 35.25 8.25 L 35.25 12 L 36.75 12 Z M 39 3 C 39.414062 3 39.75 3.335938 39.75 3.75 C 39.75 4.164062 39.414062 4.5 39 4.5 C 38.585938 4.5 38.25 4.164062 38.25 3.75 C 38.25 3.335938 38.585938 3 39 3 Z M 39 3 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 40.5 15.75 C 40.5 16.726562 41.128906 17.550781 42 17.863281 L 42 21.75 L 38.25 21.75 L 38.25 23.25 L 42.75 23.25 C 43.164062 23.25 43.5 22.914062 43.5 22.5 L 43.5 17.863281 C 44.371094 17.550781 45 16.726562 45 15.75 C 45 14.507812 43.992188 13.5 42.75 13.5 C 41.507812 13.5 40.5 14.507812 40.5 15.75 Z M 42.75 15 C 43.164062 15 43.5 15.335938 43.5 15.75 C 43.5 16.164062 43.164062 16.5 42.75 16.5 C 42.335938 16.5 42 16.164062 42 15.75 C 42 15.335938 42.335938 15 42.75 15 Z M 42.75 15 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 42.75 33 C 41.773438 33 40.949219 33.628906 40.636719 34.5 L 39.75 34.5 L 39.75 27 C 39.75 26.585938 39.414062 26.25 39 26.25 L 36.75 26.25 L 36.75 27.75 L 38.25 27.75 L 38.25 35.25 C 38.25 35.664062 38.585938 36 39 36 L 40.636719 36 C 40.949219 36.871094 41.773438 37.5 42.75 37.5 C 43.992188 37.5 45 36.492188 45 35.25 C 45 34.007812 43.992188 33 42.75 33 Z M 42.75 36 C 42.335938 36 42 35.664062 42 35.25 C 42 34.835938 42.335938 34.5 42.75 34.5 C 43.164062 34.5 43.5 34.835938 43.5 35.25 C 43.5 35.664062 43.164062 36 42.75 36 Z M 42.75 36 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 1.5 17.863281 L 1.5 22.5 C 1.5 22.914062 1.835938 23.25 2.25 23.25 L 6.75 23.25 L 6.75 21.75 L 3 21.75 L 3 17.863281 C 3.871094 17.550781 4.5 16.726562 4.5 15.75 C 4.5 14.507812 3.492188 13.5 2.25 13.5 C 1.007812 13.5 0 14.507812 0 15.75 C 0 16.726562 0.628906 17.550781 1.5 17.863281 Z M 2.25 15 C 2.664062 15 3 15.335938 3 15.75 C 3 16.164062 2.664062 16.5 2.25 16.5 C 1.835938 16.5 1.5 16.164062 1.5 15.75 C 1.5 15.335938 1.835938 15 2.25 15 Z M 2.25 15 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                        <path
                          d="M 2.25 37.5 C 3.226562 37.5 4.050781 36.871094 4.363281 36 L 6 36 C 6.414062 36 6.75 35.664062 6.75 35.25 L 6.75 27.75 L 8.25 27.75 L 8.25 26.25 L 6 26.25 C 5.585938 26.25 5.25 26.585938 5.25 27 L 5.25 34.5 L 4.363281 34.5 C 4.050781 33.628906 3.226562 33 2.25 33 C 1.007812 33 0 34.007812 0 35.25 C 0 36.492188 1.007812 37.5 2.25 37.5 Z M 2.25 34.5 C 2.664062 34.5 3 34.835938 3 35.25 C 3 35.664062 2.664062 36 2.25 36 C 1.835938 36 1.5 35.664062 1.5 35.25 C 1.5 34.835938 1.835938 34.5 2.25 34.5 Z M 2.25 34.5 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                      <div>
                        <span className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white  transition-colors">
                          Impact Gamification and Incentivization
                        </span>
                        <div className="nav-link-content hidden">
                          <p className="text-jacarta-500 dark:text-jacarta-300">
                            By gamifying and incentivizing impact actions, we
                            encourage individuals and organizations to actively
                            participate in addressing social and environmental
                            challenges, while building community and celebrating
                            progress and achievements.
                          </p>
                        </div>
                      </div>
                    </button>
                  </Tab>
                  {/* End tab */}

                  {/* End tab */}
                  {/* Supporters */}
                  <Tab className="nav-item">
                    <button
                      className="nav-link nav-link--style-2 group relative flex w-full border-b border-jacarta-100 p-6 text-left dark:border-jacarta-600"
                      type="button"
                      onClick={() => {
                        if (windowSize?.width <= 1024) {
                          setvideoModalSupporters(true);
                        }
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="60"
                        zoomAndPan="magnify"
                        viewBox="0 0 45 44.999999"
                        height="60"
                        preserveAspectRatio="xMidYMid meet"
                        version="1.0"
                        className="mr-2 h-8 w-8 flex-shrink-0 fill-accent"
                      >
                        <defs>
                          <clipPath id="50d73e4c8b">
                            <path
                              d="M 8.691406 30 L 36.421875 30 L 36.421875 44.75 L 8.691406 44.75 Z M 8.691406 30 "
                              clipRule="nonzero"
                            />
                          </clipPath>
                          <clipPath id="130874342a">
                            <path
                              d="M 8.691406 0.25 L 36.421875 0.25 L 36.421875 15 L 8.691406 15 Z M 8.691406 0.25 "
                              clipRule="nonzero"
                            />
                          </clipPath>
                        </defs>

                        <g clipPath="url(#50d73e4c8b)">
                          <path
                            d="M 24.574219 37.523438 L 26.1875 37.523438 C 26.589844 37.515625 26.957031 37.355469 27.222656 37.09375 L 33.867188 30.480469 C 34.457031 29.902344 35.402344 29.902344 35.984375 30.484375 C 36.570312 31.066406 36.570312 32.007812 35.984375 32.589844 L 35.988281 32.589844 L 27.335938 41.199219 C 27.066406 41.460938 26.695312 41.632812 26.285156 41.632812 C 26.21875 41.632812 26.15625 41.632812 26.09375 41.636719 L 18.171875 41.636719 C 18.144531 41.636719 18.117188 41.632812 18.089844 41.632812 L 18.089844 41.636719 C 17.859375 41.636719 16.511719 41.640625 16.316406 41.636719 C 16.117188 41.628906 15.914062 41.703125 15.753906 41.855469 L 12.84375 44.75 L 8.753906 44.75 C 8.742188 44.679688 8.753906 39.894531 8.753906 39.894531 C 8.746094 39.515625 8.890625 39.132812 9.179688 38.832031 L 13.886719 34.183594 C 13.894531 34.171875 13.898438 34.167969 13.90625 34.160156 L 14.003906 34.070312 L 14.011719 34.070312 C 14.90625 33.242188 16.175781 32.980469 17.480469 32.980469 L 24.496094 32.980469 C 25.324219 32.980469 25.996094 33.648438 25.996094 34.46875 C 25.996094 35.292969 25.324219 35.960938 24.496094 35.960938 L 24.496094 35.964844 L 19.011719 35.964844 C 18.578125 35.964844 18.226562 36.3125 18.226562 36.742188 C 18.222656 37.171875 18.578125 37.523438 19.007812 37.523438 L 24.574219 37.523438 "
                            fillOpacity="1"
                            fillRule="nonzero"
                          >
                            <animate
                              attributeName="opacity"
                              values="1;0.5;1"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </g>
                        <g clipPath="url(#130874342a)">
                          <path
                            d="M 20.539062 7.480469 L 18.925781 7.476562 C 18.523438 7.484375 18.160156 7.644531 17.894531 7.90625 L 11.242188 14.519531 C 10.660156 15.097656 9.714844 15.097656 9.128906 14.515625 C 8.542969 13.933594 8.542969 12.996094 9.128906 12.410156 L 9.125 12.410156 L 17.777344 3.800781 C 18.050781 3.535156 18.417969 3.371094 18.832031 3.371094 C 18.898438 3.371094 18.957031 3.367188 19.019531 3.363281 L 26.945312 3.363281 C 26.972656 3.363281 27 3.367188 27.023438 3.367188 L 27.023438 3.363281 C 27.257812 3.363281 28.601562 3.359375 28.792969 3.363281 C 28.996094 3.371094 29.203125 3.296875 29.359375 3.144531 L 32.269531 0.25 L 36.363281 0.25 C 36.375 0.324219 36.359375 5.105469 36.359375 5.105469 C 36.367188 5.484375 36.222656 5.871094 35.9375 6.164062 L 31.222656 10.816406 C 31.21875 10.824219 31.210938 10.832031 31.207031 10.839844 L 31.113281 10.929688 L 31.105469 10.929688 C 30.207031 11.757812 28.941406 12.019531 27.632812 12.019531 L 20.613281 12.019531 C 19.789062 12.019531 19.121094 11.351562 19.121094 10.53125 C 19.121094 9.707031 19.789062 9.039062 20.613281 9.039062 L 20.613281 9.035156 L 26.105469 9.035156 C 26.539062 9.035156 26.886719 8.6875 26.886719 8.257812 C 26.886719 7.828125 26.539062 7.476562 26.105469 7.476562 L 21.464844 7.480469 L 20.539062 7.480469 "
                            fillOpacity="1"
                            fillRule="nonzero"
                          >
                            <animate
                              attributeName="opacity"
                              values="1;0.5;1"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </g>
                        <path
                          d="M 25.441406 23.910156 C 25.441406 25.199219 24.59375 26 23.320312 26.203125 L 23.320312 27.210938 L 21.621094 27.210938 L 21.621094 26.144531 C 20.609375 25.980469 19.796875 25.347656 19.796875 25.347656 L 20.742188 24.105469 C 20.742188 24.105469 21.609375 24.789062 22.6875 24.789062 C 23.371094 24.789062 23.78125 24.515625 23.78125 24.074219 L 23.78125 24.046875 C 23.78125 23.628906 23.519531 23.414062 22.25 23.089844 C 20.722656 22.703125 19.730469 22.277344 19.730469 20.777344 L 19.730469 20.757812 C 19.730469 19.625 20.488281 18.804688 21.621094 18.558594 L 21.621094 17.667969 L 23.320312 17.667969 L 23.320312 18.570312 C 24.210938 18.660156 24.804688 19.140625 24.804688 19.140625 L 23.964844 20.453125 C 23.964844 20.453125 23.300781 19.945312 22.371094 19.945312 C 21.730469 19.945312 21.394531 20.238281 21.394531 20.605469 L 21.394531 20.625 C 21.394531 21.121094 21.71875 21.285156 23.03125 21.617188 C 24.574219 22.019531 25.441406 22.566406 25.441406 23.886719 Z M 22.585938 14.082031 C 17.945312 14.082031 14.1875 17.824219 14.1875 22.441406 C 14.1875 27.054688 17.945312 30.800781 22.585938 30.800781 C 27.226562 30.800781 30.988281 27.054688 30.988281 22.441406 C 30.988281 17.824219 27.226562 14.082031 22.585938 14.082031 "
                          fillOpacity="1"
                          fillRule="nonzero"
                        >
                          <animate
                            attributeName="opacity"
                            values="1;0.5;1"
                            dur="2s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>

                      <div>
                        <span className="mb-2 mt-1 block font-display text-xl font-medium text-jacarta-700 group-hover:text-accent dark:text-white  transition-colors">
                          Impact Art for Earning and Support
                        </span>
                        <div className="nav-link-content hidden">
                          <p className="text-jacarta-500 dark:text-jacarta-300">
                            Our Impact Arts provides a win-win scenario for
                            earning and supporting impact initiatives. It
                            presents a means for influencers, brands, causes and
                            community to build a transparent economy of impact.
                          </p>
                        </div>
                      </div>
                    </button>
                  </Tab>
                  {/* End tab */}

                  {/* End tab */}
                </TabList>
              </div>
              {/* End tablist */}

              <div className="flex items-center justify-center lg:w-[57%]">
                {/* <!-- content --> */}
                <div className="tab-content flex-1">
                  {/* Impact Intiatives */}
                  <TabPanel>
                    <div className="relative">
                      <figure className="hidden lg:flex items-center justify-center">
                        <Image
                          width={526}
                          height={526}
                          src="/images/impactoverse-for/impact_Intiative.png"
                          alt="benifit"
                          className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600 object-contain"
                        />
                        {/* <Image
                    width={630}
                    height={594}
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  /> */}
                        <button
                          onClick={() => setvideoModalImpactIntiative(true)}
                          className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                          </svg>
                        </button>
                      </figure>
                      <div
                        className={
                          videoModalImpactIntiative
                            ? "modal lightbox fade show block"
                            : "modal lightbox fade"
                        }
                      >
                        <div className="modal-dialog modal-dialog-centered modal-xl w-full">
                          <div className="modal-content border-0 bg-transparent">
                            <div className="modal-body p-0 relative">
                              <button
                                onClick={() => (
                                  handleVideo(),
                                  setvideoModalImpactIntiative(false)
                                )}
                                type="button"
                                className="btn-close position-absolute top-0 end-0 p-3 z-10"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 16 16"
                                  fill="#fff"
                                  className="h-6 w-6"
                                >
                                  <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                                </svg>
                              </button>
                              <div
                                id="lightboxCarousel-d7ewe4ig"
                                className="lightbox-carousel carousel"
                              >
                                <div className="carousel-inner">
                                  <div className="carousel-item active">
                                    <div className="position-absolute top-50 start-50 translate-middle text-white">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      ></div>
                                    </div>
                                    <div className="ratio ratio-16x9">
                                      <iframe
                                        id="video"
                                        src="https://www.youtube.com/embed/FhiTWemqr5Y"
                                        title="Impact Intiative - Supporter for Impact"
                                        allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                                      ></iframe>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  {/* Brands & Influencers */}
                  <TabPanel>
                    <div className=" relative">
                      <figure className="hidden lg:flex items-center justify-center">
                        <Image
                          width={526}
                          height={526}
                          src="/images/impactoverse-for/brands_and_Influencers.png"
                          alt="benifit"
                          className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600  object-contain"
                        />
                        {/* <Image
                    width={630}
                    height={594}
                    src="/images/dao/3d_elements_circle.png"
                    alt="circle"
                    className="absolute animate-spin-slow"
                  /> */}
                        <button
                          onClick={() => setvideoModalBrand(true)}
                          className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                          </svg>
                        </button>
                      </figure>
                      <div
                        className={
                          videoModalBrand
                            ? "modal lightbox fade show block"
                            : "modal lightbox fade"
                        }
                      >
                        <div className="modal-dialog modal-dialog-centered modal-xl w-full">
                          <div className="modal-content border-0 bg-transparent">
                            <div className="modal-body p-0 relative">
                              <button
                                onClick={() => (
                                  handleVideo(), setvideoModalBrand(false)
                                )}
                                type="button"
                                className="btn-close position-absolute top-0 end-0 p-3 z-10"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 16 16"
                                  fill="#fff"
                                  className="h-6 w-6"
                                >
                                  <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                                </svg>
                              </button>
                              <div
                                id="lightboxCarousel-d7ewe4ig"
                                className="lightbox-carousel carousel"
                              >
                                <div className="carousel-inner">
                                  <div className="carousel-item active">
                                    <div className="position-absolute top-50 start-50 translate-middle text-white">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      ></div>
                                    </div>
                                    <div className="ratio ratio-16x9">
                                      <iframe
                                        id="video"
                                        src="https://www.youtube.com/embed/usnTfMiEG_4"
                                        title="Brands & Influencers"
                                        allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                                      ></iframe>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Supporters */}
                  <TabPanel>
                    <div className="relative">
                      <figure className="hidden lg:flex items-center justify-center">
                        <Image
                          width={526}
                          height={526}
                          src="/images/impactoverse-for/supporters.png"
                          alt="benifit"
                          className="rounded-full border border-jacarta-100 p-14 dark:border-jacarta-600 object-contain"
                        />
                        {/* <Image
                    width={630}
                    height={594}
                    src="/images/dao/3d_elements_circle.png"
                    alt="benifit"
                    className="absolute animate-spin-slow"
                  /> */}

                        <button
                          onClick={() => setvideoModalSupporters(true)}
                          className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="h-8 w-8 fill-white"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                          </svg>
                        </button>
                      </figure>
                      <div
                        className={
                          videoModalSupporters
                            ? "modal lightbox fade show block"
                            : "modal lightbox fade"
                        }
                      >
                        <div className="modal-dialog modal-dialog-centered modal-xl w-full">
                          <div className="modal-content border-0 bg-transparent">
                            <div className="modal-body p-0 relative">
                              <button
                                onClick={() => (
                                  handleVideo(), setvideoModalSupporters(false)
                                )}
                                type="button"
                                className="btn-close position-absolute top-0 end-0 p-3 z-10"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 16 16"
                                  fill="#fff"
                                  className="h-6 w-6"
                                >
                                  <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                                </svg>
                              </button>
                              <div
                                id="lightboxCarousel-d7ewe4ig"
                                className="lightbox-carousel carousel"
                              >
                                <div className="carousel-inner">
                                  <div className="carousel-item active">
                                    <div className="position-absolute top-50 start-50 translate-middle text-white">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      ></div>
                                    </div>
                                    <div className="ratio ratio-16x9">
                                      <iframe
                                        id="video"
                                        src="https://www.youtube.com/embed/cmFA-3Oqdy0"
                                        title="Supporters"
                                        allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                                      ></iframe>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </div>
          </Tabs>
        </div>
      </section>
      {/* <h2 className="mb-5 font-display text-3xl text-jacarta-700 dark:text-white text-center">
        Launch a campaign
      </h2> */}
      {/* <!-- end benefits --> */}
    </>
  );
};

export default Benifits;
